export interface EmailRecordResponse {
    EmailRecord: EmailRecord;
    EmailRecords: EmailRecord[];
}
export interface EmailRecordState{
    SelectedRecord?: EmailRecord,
    SearchResult: EmailRecord[]
}

export class EmailRecord {
    id?: string;
    userId?: string;
    tenantId?: string
    matterId?: number;
    matterName?: string;
    clientId?: number;
    clientName?: string;
    subject?: string;
    body?: string;
    htmlText?: string;
    messageUuid?: string
    messageHash?: string;
    dateSentOrReceived?: Date;
    to?: BaseEmailInformation[];
    cc?: BaseEmailInformation[];
    bcc?: BaseEmailInformation[];
    from?: BaseEmailInformation;
    attachmentInformation?: Attachment[];
    groupId?:number =0;
}
class Attachment {
    Id: number =0;
    AttachmentName: string = '';
    TypeOfAttachment: AttachmentType =1;
}
class BaseEmailInformation
{
    Name: string ='';
    Email: string ='';
    Recipient: RecipientCategory = 1;
}
enum RecipientCategory
{

    To = 1,
    Cc = 2,
    Bcc = 3,
    Sender = 4
}
enum AttachmentType
{
    EmailAttachment = 1,
    MsgFile = 2
}
